import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Title')(() =>
  css({
    display: 'flex',
    paddingTop: ['l', 'l', '0'],
    mb: 'm',
  }),
);

themeStyles.addBaseStyles('Wrapper')(() =>
  css({
    display: 'flex',
    gap: 's',
    alignItems: 'center',
  }),
);

themeStyles.addBaseStyles('CheckboxLabel')(() =>
  css({
    fontFamily: 'default',
    fontSize: ['14px', '16px', '16px'],
    lineHeight: ['22px', '26px', '26px'],
  }),
);

themeStyles.addBaseStyles('CheckboxWrapper')(() =>
  css({
    marginTop: '-4px',
  }),
);

export default themeStyles;
